import { Controller } from "@hotwired/stimulus"

// Referred from `app/assets/javascripts/containers_load_list_modal.js`
export default class extends Controller {
  static targets = [
    'statusDropdown'
  ];

  ///////////////
  /// Actions ///
  ///////////////

  setToFull() {
    this.statusDropdownTargets.forEach((status) => {
      $(status).val('full').change();
    })
  }

  setToEmpty() {
    this.statusDropdownTargets.forEach((status) => {
      $(status).val('empty').change();
    })
  }

  setToCurrentStatus() {
    this.statusDropdownTargets.forEach((status) => {
      $(status).val(status.dataset.currentStatus).change();
    })
  }
}
